import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthGate } from "./AuthGate";
import "./styles/tokens.css";

const rootEl = document.getElementById("app");
if (!rootEl) throw new Error("missing #app");
createRoot(rootEl).render(
  <StrictMode>
    <AuthGate />
  </StrictMode>,
);
